import { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";

import obtenerContribuyente from "../helpers/contribuyente/contribuyente/obtenerContribuyente";

/**
 * Componente modal para mostrar lista de contribuyentes
 * @param {Object} param0 
 * @returns Componente React
 */
export default function Modal({ onRequestClose, contribuyentes, setData }) {

    useEffect(() => {
        function onKeyDown(event) {
            if (event.keyCode === 27) onRequestClose();
        }

        document.body.style.overflow = "hidden";
        document.addEventListener("keydown", onKeyDown);

        return () => {
            document.body.style.overflow = "visible";
            document.removeEventListener("keydown", onKeyDown);
        };
    });

    function elegirContribuyente(idContribuyente) {
        obtenerContribuyente(idContribuyente, setData);
        onRequestClose();
    }

    return (
        <div id="listaContribuyentes" className="tabcontent" onClick={e => e.target.className === "overlay" && onRequestClose()}>

            <div className="overlay" id="overlay">
                <div className="popup" id="popup">

                    <Link to="#" id="btn-cerrar-popup" className="btn-cerrar-popup" onClick={onRequestClose}><span
                        className="material-icons">closed</span></Link>

                    <div className="contenedorForm">

                        <div className="tituloForm actions">Seleccionar Contribuyente</div>
                        <div className="encabezadoForm">Persona</div>
                        <div className="encabezadoForm">Nombre | Razon Social</div>
                        <div className="encabezadoForm">RFC</div>
                        <div className="encabezadoForm">Concesiones</div>

                        {contribuyentes.map(item => {
                            return (
                                <Fragment key={item.idContribuyente} >
                                    <div className="filaForm" onClick={() => elegirContribuyente(item.idContribuyente)}>
                                        {item.tipoPersona === 0 ? "Física" : "Moral"}
                                    </div>
                                    <div className="filaForm" onClick={() => elegirContribuyente(item.idContribuyente)}>
                                        {`${item.nombre} ${item.apellidoPaterno} ${item.apellidoMaterno}`}
                                    </div>
                                    <div className="filaForm" onClick={() => elegirContribuyente(item.idContribuyente)}>{item.rfc.toUpperCase()}</div>
                                    <div className="filaForm" onClick={() => elegirContribuyente(item.idContribuyente)}>{item.concesiones.toUpperCase()}</div>
                                </Fragment>
                            )
                        })}

                    </div>
                </div>
            </div>
        </div>
    );
};
